var map = {
	"./1.png": "b8c3c",
	"./2.png": "9305",
	"./csv.png": "9d02",
	"./doc.png": "6839",
	"./file-27_icon-icons.com_62081.png": "248c",
	"./folder.png": "e8c5",
	"./format_extension_png_page_file_icon_124654.png": "862b",
	"./jpeg.png": "e287",
	"./jpg.png": "9ed0",
	"./pdf.png": "2cd5",
	"./pdf2.png": "db8d",
	"./png.png": "82f4",
	"./ppt.png": "dc53",
	"./txt.png": "06fe",
	"./unknown.png": "0e6f",
	"./xls.png": "e157",
	"./xlss.png": "cc19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9954";